// extracted by mini-css-extract-plugin
export var dropdown = "_p2-1";
export var hidden = "_p2-0";